<script lang="ts">
  import { getContext, onDestroy, SvelteComponent } from "svelte";
  import type { Combinator } from "../combinators";
  import { ROUTER, LOCATION } from "./contexts";
  import type { RouteLocation, StateLocation } from "./route_location";
  import type { RouterContext } from "./utils2";

  type RouteParams = $$Generic;
  export let path: Combinator<RouteParams> | null = null;
  // export let component: SvelteComponent | null = null;

  const { registerRoute, unregisterRoute, activeRoute } = getContext<RouterContext>(ROUTER);
  const location = getContext<SvelteStore<StateLocation>>(LOCATION);

  const route = {
    path,
  };
  $: routeParams =
    $activeRoute !== null && $activeRoute.route === route ? { params: $activeRoute.params as RouteParams } : null;

  registerRoute(route);

  // There is no need to unregister Routes in SSR since it will all be
  // thrown away anyway.
  if (typeof window !== "undefined") {
    onDestroy(() => {
      unregisterRoute(route);
    });
  }
</script>

{#if routeParams !== null}
  <slot params={routeParams.params} location={{ ...$location, route: activeRoute }} />
{/if}
